import { Analytics } from '@segment/analytics-node';
import appConfig from 'app-config';
import { v4 as uuidv4 } from 'uuid';
import { getUserAgentName } from 'flow/utils/call-utils';
import { getIntegrationHost, isIntegration } from 'flow/utils/is-integration';

class SegmentClient {
    init(customerKey) {
        if (this.initialized) {
            return;
        }
        if (appConfig.production) {
            this.analytics = new Analytics({
                writeKey: 'GWcHKRi95XufxjRm6PaVxwgNfvX9ydxp',
            });
        } else {
            this.analytics = {
                identify: (identificationData) => {
                    console.info(
                        'Segment [identify]:',
                        JSON.stringify(identificationData),
                    );
                },
                track: (trackingData) => {
                    console.info(
                        'Segment [track]:',
                        JSON.stringify(trackingData),
                    );
                },
            };
        }

        const anonymousId = uuidv4();
        const trackingObject = {
            anonymousId,
            traits: {
                customerId: customerKey,
                isCti: isIntegration(),
                ctiHost: getIntegrationHost(),
            },
        };

        this.analytics.identify(trackingObject);
        this.initialized = true;
        this.customerKey = customerKey;
        this.anonymousId = anonymousId;
    }

    track(event, properties) {
        if (!this.initialized) {
            console.warn(
                'The Segment client is not initialized. Not tracking.',
            );
            return;
        }

        const trackingObject = {
            anonymousId: this.anonymousId,
            event: event,
        };

        if (properties) {
            properties.device = getUserAgentName();
            trackingObject.properties = properties;
        } else {
            trackingObject.properties = { device: getUserAgentName() };
        }

        this.analytics.track(trackingObject);
    }
}

const segmentClient = new SegmentClient();
export default segmentClient;
